// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const pageReady = (): void => {};
